import { useState, useEffect } from 'react';
import { useTokenLS } from './useTokenLS';

// NOTE: 
// 10-05-2023: 
// This is an earlier attempt at creating useUser;
// This hook should be removed eventually after managing any dependencies as it is not optimised and not really needed


export const useUser = () => {
    const [token] = useTokenLS();

    const getPayloadFromToken = token => {
        const encodedPayload = token.split('.')[1];
        return JSON.parse(atob(encodedPayload));
    }

    const [user, setUser] = useState(() => {
        if (!token) return null;
        return getPayloadFromToken(token);
    });

    useEffect(() => {
        if (!token) {
            setUser(null);
        } else {
            setUser(getPayloadFromToken(token));
        }
    }, [token]);

    return user;
}